module.exports = __webpack_public_path__ + "media/images/dropdown/arrow-right-a7860e0644a4d765449ce2db8a10c689.png";